// Mirror of the backend SubscriptionPlan enum. Keep these in sync with
// backend-mcp-showcase/.../app/model/subscription/SubscriptionPlan.java
export const subscriptionPlan = {
  FREE: "free",
  LITE: "lite",
  PRO: "pro",
  ENTERPRISE: "enterprise",
};

// The plans offered self-serve (Free is retired; Personalized/Enterprise is contact-sales).
export const selfServePlans = [subscriptionPlan.LITE, subscriptionPlan.PRO];

export const subscriptionUserLimits = {
  [subscriptionPlan.FREE]: 1,
  [subscriptionPlan.LITE]: 1,
  [subscriptionPlan.PRO]: 2,
  // Matches SubscriptionPlan.ENTERPRISE.maxUsers (fallback only; the server ships the real value).
  [subscriptionPlan.ENTERPRISE]: 1000,
};

export const subscriptionPlaygroundLimits = {
  [subscriptionPlan.FREE]: 0,
  [subscriptionPlan.LITE]: 1,
  [subscriptionPlan.PRO]: 2,
  [subscriptionPlan.ENTERPRISE]: 999,
};

// Max MCP tools kept active (included in demos / live chat / widget) per plan.
export const subscriptionToolLimits = {
  [subscriptionPlan.FREE]: 0,
  [subscriptionPlan.LITE]: 10,
  [subscriptionPlan.PRO]: 20,
  [subscriptionPlan.ENTERPRISE]: 999,
};

export const subscriptionWorkspaceLimits = {
  [subscriptionPlan.FREE]: 1,
  [subscriptionPlan.LITE]: 1,
  [subscriptionPlan.PRO]: 2,
  [subscriptionPlan.ENTERPRISE]: 999,
};

// Live Chat monthly message caps (mirror of SubscriptionPlan.maxMonthlyMessages).
// 0 = feature disabled (upgrade to unlock). Lite has no Live Chat; Pro allows 1k/month.
export const subscriptionLiveChatMessageLimits = {
  [subscriptionPlan.FREE]: 0,
  [subscriptionPlan.LITE]: 0,
  [subscriptionPlan.PRO]: 1000,
  [subscriptionPlan.ENTERPRISE]: 10000,
};

// Whether a plan includes the Live Chat feature at all.
export const planHasLiveChat = (plan) =>
  (subscriptionLiveChatMessageLimits[plan] ?? 0) > 0;
